export default "__VITE_ASSET__CljVcrSS__"